import InfoIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';
import {
  CLICK_TO_VIEW_ERROR_DETAILS,
  CLICK_TO_VIEW_EXPORT_DETAILS,
} from '../../content';
import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface ErrorIconProps {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: () => void;
  size?: 'small' | 'medium' | 'large';
  tooltip?: string;
  color?: string;
}

const useStyles = makeStyles(() => ({
  icon: {
    cursor: 'pointer',
    fontSize: '16px',
    padding: '2px',
    '& svg': {
      color: 'inherit',
    },
  },
  error: {
    color: 'red',
  },
  info: {
    color: 'lightgray !important',
    '&:hover': {
      color: 'gray !important',
    },
  },
}));

/**
 * Info icon next to export status.
 * Red opens the failure log; lightgray opens export ID / platform / type.
 */
const ErrorIcon: React.FC<ErrorIconProps> = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  color = 'red',
  tooltip,
}) => {
  const classes = useStyles();
  const isExportInfo = color === 'lightgray';

  return (
    <Tooltip
      title={
        tooltip ||
        (isExportInfo
          ? CLICK_TO_VIEW_EXPORT_DETAILS
          : CLICK_TO_VIEW_ERROR_DETAILS)
      }
      arrow
      placement="top"
    >
      <IconButton
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        size="small"
        className={`${classes.icon} ${
          isExportInfo ? classes.info : classes.error
        }`}
        aria-label={
          isExportInfo ? 'View export details' : 'View error details'
        }
      >
        <InfoIcon style={{ fontSize: '20px' }} />
      </IconButton>
    </Tooltip>
  );
};

export default ErrorIcon;
